import React from 'react';
import { Container } from 'swag-client-common/components/ui/container';
import LoadingOverlay from 'swag-client-common/components/ui/loading-overlay';
import StripeElementsContext from 'swag-client-common/components/partials/stripe-elements-provider';
import { PaymentDetailsPublicApi } from './components/public-api-card-form';
import { CreditCardControlPanel } from './components/card-control-panel';
import classes from './public-api-payment.scss';
const InjectedPaymentSettings = ({
  isCreditCardExist
}) => {
  return /*#__PURE__*/React.createElement("div", {
    className: classes.paymentSettingsWrapper
  }, /*#__PURE__*/React.createElement("h2", {
    className: classes.title
  }, "Payment Details"), /*#__PURE__*/React.createElement("div", {
    className: classes.paymentDetailsWrapper
  }, /*#__PURE__*/React.createElement(PaymentDetailsPublicApi, {
    isDeliveryToCustomer: false,
    isSaveAvailable: false,
    isSelectCardShown: false,
    hideStripeLogo: true,
    disableWholeForm: isCreditCardExist
  })), /*#__PURE__*/React.createElement(CreditCardControlPanel, {
    isCardExist: isCreditCardExist
  }));
};
const PublicApiPayment = props => {
  return /*#__PURE__*/React.createElement(Container, {
    innerClassName: classes.innerContainer
  }, /*#__PURE__*/React.createElement("p", {
    className: classes.descr
  }, "Please enter the credit card you would like to use to pay for the swag distributions that are triggered automatically through the API. These charges will cover all of the costs associated with shipping swag to your recipients, including any VAT and duty fees for international shipments. Please note a credit card is required in order to enable API shipments."), /*#__PURE__*/React.createElement(StripeElementsContext, null, /*#__PURE__*/React.createElement(InjectedPaymentSettings, props)), /*#__PURE__*/React.createElement(LoadingOverlay, {
    isShown: props.isLoading
  }));
};
export { PublicApiPayment };